import useAuthenticatedMutation from '@datahooks/admin/useAuthenticatedMutation';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_BASE_URL, FUNCTION_KEY, PROJECT_SCOPE } from '@home/config';
import logError from '@datahooks/metadata/ErrorLogging';

// Core function that performs attach/detach operations
const manageEventLink = async ({ data, method }, token) => {
    let url = `${API_BASE_URL}event_test_link`;

    if (method === 'DELETE' && data.link_id) {
        url += `?link_id=${data.link_id}`;
    }

    try {
        const response = await axios({
            method,
            url,
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-functions-key': FUNCTION_KEY,
            },
            data: method !== 'DELETE' ? data : {}, // DELETE doesn't need a body
        });

        return response.data;
    } catch (error) {
        logError(`Failed to ${method.toLowerCase()} event link:`, error, {});
        throw (error?.response?.data) ? error.response.data : error;
    }
};

// Hook for managing attach/detach of event-test links
export default function useEventLinkManager(onSuccess, onError) {
    const projectScope = [PROJECT_SCOPE];
    
    const { mutate, isLoading, isError, error, data, reset } = useAuthenticatedMutation(manageEventLink, projectScope, {
        onSuccess,
        onError,
    });

    const performAction = (data, method = 'POST') => {
        return new Promise((resolve, reject) => {
            mutate(
                { data, method },
                {
                    onSuccess: (result) => {
                        resolve(result);
                        if (onSuccess) onSuccess(result);
                    },
                    onError: (error) => {
                        const err = error instanceof Error ? error : new Error(String(error));
                        reject(err);
                        if (onError) onError(error);
                    },
                }
            );
        });
    };

    return {
        performAction,
        isLoading,
        isError,
        error,
        data,
        reset,
    };
}

useEventLinkManager.propTypes = {
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
};
